export default class BadRequestException extends Error {
    statusCode: number;

    constructor(message: string, statusCode: number) {
        super(message);
        this.name = 'Bad Request Exception';
        this.statusCode = statusCode;
    }
}